import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=7f02c8fd&"
import script from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f02c8fd')) {
      api.createRecord('7f02c8fd', component.options)
    } else {
      api.reload('7f02c8fd', component.options)
    }
    module.hot.accept("./LanguagesList.vue?vue&type=template&id=7f02c8fd&", function () {
      api.rerender('7f02c8fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderLanguageToggle/components/LanguagesList.vue"
export default component.exports